import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import * as S from 'src/modules/programs/stepComponents/styles';

import stepIcon from 'src/public/img/group-4@3x.png';

type Props = WithTranslation;

export const ThinkingMoreAboutValuesStep = withTranslation('cp')(({ t }: Props) => {
    const elements: string[] = t('week-2.thinking-more-about-values.elements', {
        returnObjects: true,
    });

    return (
        <>
            <S.ContentRow>
                <S.ContentColumn>
                    <S.StepHeading small>
                        {t('week-2.thinking-more-about-values.subheading')}
                    </S.StepHeading>
                    <S.StepHeading>{t('week-2.thinking-more-about-values.heading')}</S.StepHeading>
                </S.ContentColumn>
            </S.ContentRow>
            <S.ContentRow>
                <S.ContentColumn md={14}>
                    <S.BulletList>
                        {elements.map((text: string) => (
                            <S.BulletListElement key={text}>{text}</S.BulletListElement>
                        ))}
                        <S.StepDescription small>
                            {t('week-2.thinking-more-about-values.reminder')}
                        </S.StepDescription>
                    </S.BulletList>
                </S.ContentColumn>
                <S.ContentColumn md={10}>
                    <S.StepIcon iconUrl={stepIcon} />
                </S.ContentColumn>
            </S.ContentRow>
        </>
    );
});
